// extracted by mini-css-extract-plugin
module.exports = {"list":"toast-container_list__SO40q","item":"toast-container_item__IovGp"};